
import { Component, Prop, Vue } from "vue-property-decorator"
import { getOptimalTextColor } from "@/helpers/data"
import { commonModule, labelModule } from "@/store/modules/store-accessor"
import LabelExistsAlert from "@/components/Alerts/LabelExistsAlert.vue";
import _ from "lodash";

@Component({
  components: {
    LabelExistsAlert,
  }
})
export default class EditExpenseLabelModal extends Vue {
    @Prop() payload!: Record<string, any>;

    labelModel: LabelDto = { id: 0, name: '', color: '#FFFFFF' };

    isEditing = false;

    mounted() {
        this.labelModel = _.cloneDeep(this.payload.label);
    }

    labelExists = false;

    nameRules = [
        (val: any) => !!val || this.$i18n.t('nameRequired'),
        (val: any) => val.length <= 50 || this.$i18n.t('nameLengthRule'),
    ];


    optimalTextColor(color: string) {
        return getOptimalTextColor(color);
    }

    hideModal() {
        commonModule.hideModal();
    }

    get showNameOrPreview() {
        return this.labelModel.name || this.$i18n.t('labelPreview');
    }

    get canEdit() {
        return !(!this.labelExists && this.labelModel.name.replace(/ /g, '').replace(/-/g, '').length > 0);
    }

    updateExists(value: boolean) {
        this.labelExists = value;
    }

    async doEditExpenseLabel() {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.isEditing = true;

            await labelModule.updateExpenseLabel(this.labelModel);

            this.isEditing = false;
            this.hideModal();
        }
    }
}
